export default __webpack_public_path__ + "static/media/vrf5.666fc70a.jpg";